"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareTeam = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const CareTeamList_1 = require("./CareTeamList");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
exports.CareTeam = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(({ intl, careTeamProviders, createAvailabilityUrl, createProviderUrl, track }) => {
    const careTeamSubtitle = intl.formatMessage(messages_1.default.careTeamSubtitle);
    // default subtitle is empty
    const shouldShowSubtitle = careTeamSubtitle !== ' ';
    return (react_1.default.createElement(card_container_1.default, null,
        react_1.default.createElement(styles_1.CareTeamHeader, null,
            react_1.default.createElement(styles_1.CareTeamTitle, null, intl.formatMessage(messages_1.default.careTeamTitle)),
            shouldShowSubtitle && (react_1.default.createElement(styles_1.CareTeamSubtitle, null, careTeamSubtitle))),
        react_1.default.createElement(CareTeamList_1.CareTeamList, { careTeamProviders: careTeamProviders, createAvailabilityUrl: createAvailabilityUrl, createProviderUrl: createProviderUrl, track: track })));
}));
//# sourceMappingURL=CareTeam.js.map